import * as React from 'react';
import {MockupList} from '../../../../node_modules/argo-ui';

export const Loading = () => (
    <div style={{margin: 20}}>
        <MockupList />
    </div>
);
